import "./cute.css";
const cuteAlert = ({
  type,
  title,
  message,
  img,
  buttonText = "OK",
  confirmText = "OK",
  vibrate = [],
  playSound = null,
  cancelText = "Cancel",
  closeStyle,
}) => {
  return new Promise((resolve) => {
    const existingAlert = document.querySelector(".alert-wrapper");

    if (existingAlert) {
      existingAlert.remove();
    }

    const body = document.querySelector("body");

    const scripts = document.getElementsByTagName("script");

    // let src = "";

    for (let script of scripts) {
      if (script.src.includes("cute-alert.js")) {
        // src = script.src.substring(0, script.src.lastIndexOf("/"));
      }
    }

    let btnTemplate = `
      <button class="alert-button ${type}-bg ${type}-btn">${buttonText}</button>
      `;

    if (type === "question") {
      btnTemplate = `
        <div class="question-buttons">
          <button class="confirm-button ${type}-bg ${type}-btn">${confirmText}</button>
          <button class="cancel-button error-bg error-btn">${cancelText}</button>
        </div>
        `;
    }

    if (vibrate.length > 0) {
      navigator.vibrate(vibrate);
    }

    if (playSound !== null) {
      let sound = new Audio(playSound);
      sound.play();
    }

    // console.log(img);
    const template = `
      <div class="alert-wrapper">
        <div class="alert-frame">
          ${img ? `
            <div class="alert-header ${type}-bg">
              <span class="alert-close">X</span>
              <img class="alert-img" src="${img}" />
            </div>
          ` : `
            <div class="alert-header-simple">
              <span class="alert-close">X</span>
            </div>
          `}
          <div class="alert-body">
            <h2 class="alert-title">${title}</h2>
            <p class="alert-message">${message}</p>
            ${btnTemplate}
          </div>
        </div>
      </div>
      `;

    body.insertAdjacentHTML("afterend", template);

    const alertWrapper = document.querySelector(".alert-wrapper");
    const alertFrame = document.querySelector(".alert-frame");
    const alertClose = document.querySelector(".alert-close");

    if (type === "question") {
      const confirmButton = document.querySelector(".confirm-button");
      const cancelButton = document.querySelector(".cancel-button");

      confirmButton.addEventListener("click", () => {
        alertWrapper.remove();
        resolve("confirm");
      });

      cancelButton.addEventListener("click", () => {
        alertWrapper.remove();
        resolve();
      });
    } else {
      const alertButton = document.querySelector(".alert-button");

      alertButton.addEventListener("click", () => {
        alertWrapper.remove();
        resolve("ok");
      });
    }

    alertClose.addEventListener("click", () => {
      alertWrapper.remove();
      resolve("close");
    });

    /*     alertWrapper.addEventListener('click', () => {
        alertWrapper.remove();
        resolve();
      }); */

    alertFrame.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  });
};

export const cuteToast = ({
  type,
  message,
  timer = 5000,
  vibrate = [],
  playSound = null,
  img,
  title,
}) => {
  return new Promise((resolve) => {
    const body = document.querySelector("body");

    const scripts = document.getElementsByTagName("script");

    // let src = "";

    for (let script of scripts) {
      if (script.src.includes("cute-alert.js")) {
        // src = script.src.substring(0, script.src.lastIndexOf("/"));
      }
    }

    let templateContainer = document.querySelector(".toast-container");

    if (!templateContainer) {
      body.insertAdjacentHTML(
        "afterend",
        '<div class="toast-container"></div>'
      );
      templateContainer = document.querySelector(".toast-container");
    }

    const toastId = id();

    if (type === "success") {
      img =
        "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/icons/success.svg";
    } else {
      img =
        "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/icons/error.svg";
    }
    // else if(type === '')

    const templateContent = `
      <div class="toast-content ${type}-bg" id="${toastId}-toast-content">
        <div>
          <div class="toast-frame">
            <div class="toast-body">
              
              ${
                img !== ""
                  ? '<img class="toast-body-img" src="' + img + '" />'
                  : ""
              }
              <div class="toast-body-content">
                <span class="toast-title">${title}</span>
                <span class="toast-message">${message}</span>
              </div>
              <div class="toast-close d-none" id="${toastId}-toast-close">X</div>
            </div>
          </div>
          ${
            img !== ""
              ? '<div class="toast-timer ' +
                type +
                '-timer"  style="animation: timer' +
                timer +
                "ms linear;>"
              : "<h1>Akash</h1>"
          }
        </div>
      </div>
      `;

    const toasts = document.querySelectorAll(".toast-content");

    if (toasts.length) {
      toasts[0].insertAdjacentHTML("beforebegin", templateContent);
    } else {
      templateContainer.innerHTML = templateContent;
    }

    const toastContent = document.getElementById(`${toastId}-toast-content`);

    if (vibrate.length > 0) {
      navigator.vibrate(vibrate);
    }

    if (playSound !== null) {
      let sound = new Audio(playSound);
      sound.play();
    }

    setTimeout(() => {
      toastContent.remove();
      resolve();
    }, timer);

    const toastClose = document.getElementById(`${toastId}-toast-close`);

    toastClose.addEventListener("click", () => {
      toastContent.remove();
      resolve();
    });
  });
};

const id = () => {
  return "_" + Math.random().toString(36).substr(2, 9);
};

export default cuteAlert;
